<template>
  <div class="container">
    <div class="container pR" v-if="$store.state.isPc">
      <div class="left">
        <img :src="logoImg" class="logo">
        <div style="width: 260px;height: 90px;" class="pR flexVC">
          <div class="title">趁早行动</div>
          <div class="w100 pR title-line-box">
            <div class="titleLine"></div>
            <div class="titleLine-animation"
                 :class="currentIndex == 4 ? 'titleLine-animation-index' : '' "></div>
          </div>
        </div>
        <div class="content">{{content}}</div>
        <div class="btn-more-box" @mouseenter="moreEnter" @mouseleave="moreLeave">
          <div class="btn-more flexHC2" :class="isHover ? 'btn-more-hover' : ''">
          </div>
          <div class="btn-more-text flexHC2" :class="isHover ? 'CFFF' : 'C000'">
            <span>了解更多</span>
            <img :src="isHover ? whiteArrow : arrow"
                 style="width: 15px;height: 11px;margin-left: 5px;">
          </div>

          <div class="flexVC code-box" v-show="isHover">
            <div class="code-content flexVC2">
              <img src="../../../assets/images/icon_wx_app_code.jpg"
                   style="width: 103px;height: 103px;margin-left: 5px;margin-top: 2px;">
              <span style="margin-top: 18px;">微信扫一扫</span>
            </div>
          </div>
        </div>
      </div>
      <img :src="wxappImg"
           style="height: calc(100% - 80px);position: absolute;right: 8vw;top: 80px;">
    </div>
    <div class="container-m pR flexVC" v-if="!$store.state.isPc">
      <div style="height: 13.9%;"></div>
      <div style="width: 1.9rem;height: 0.6rem;" class="pR flexVC">
        <div class="title-m">趁早行动</div>
        <div class="w100 pR title-line-box-m">
          <div class="titleLine-m"></div>
          <div class="titleLine-animation-m"
               :class="currentIndex == 4 ? 'titleLine-animation-index-m' : '' "></div>
        </div>
      </div>
      <div class="content-m" style="margin-top: 0.4rem;">{{content}}</div>
      <div class="btn-more-box-m flexHC2" @click="showModal">
        <span>了解更多</span>
        <img :src="isHover ? arrow : arrow"
             style="width: 0.18rem;height: 0.16rem;margin-left: 5px;">
      </div>
      <img :src="wxappImgM" class="wxapp-img-m">
      <code-modal :codeImg="currentCodeData.codeImg" :title="currentCodeData.nickname" :type="1"
                  :subtitle="currentCodeData.tips"  @closeModal="closeModal" v-show="isShowModal"></code-modal>

    </div>
  </div>
</template>

<script>
  import whiteArrow from '@/assets/images/icon_home_right_arrow_white.png'
  import arrow from '@/assets/images/icon_home_right_arrow.png'
  import logoImg from '@/assets/images/icon_logo.png'
  import codeImg from '@/assets/images/icon_wx_app_code.jpg'
  import codeModal from '@/components/CodeModal'

  export default {
    name: "HomeFourth",
    props: ["currentIndex"],
    data() {
      return {
        content: '「趁早行动」是趁早基于微信生态打造的一款践行“长期主义”与“知行合一”的小程序。以「百日计划」系列为核心，提供完备的内容&方法论和服务，支持使用者知行合一',
        isHover: false,
        whiteArrow: whiteArrow,
        arrow: arrow,
        logoImg: logoImg,
        wxappImg: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/icon_home_wxapp.png',
        wxappImgM: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/mobile/icon_home_3.png',
        homeTime: [],
        isShowModal:false,
        currentCodeData: {
          codeImg: codeImg,
          nickname: '',
          tips: '请扫码查看',
        },
      }
    },


    components: {
      codeModal,
    },

    mounted() {
      // this.homeTime = homeTime
    },

    watch: {
      currentIndex(val) {
      }
    },

    methods: {
      closeModal(){
        this.isShowModal = false
      },
      showModal(){
        this.isShowModal = true
      },
      moreEnter(e) {
        this.isHover = true
        // console.log('111111111111111111', this.$refs.more.$el)
        // this.$refs.more.$el.style.cssText = '-webkit-animation: fadeIn 0.3s linear 1;animation: fadeIn 0.3s linear 1;animation-fill-mode: forwards;';
        // this.$refs.moreTest.$el.style.cssText = 'color: #fff;'
      },
      moreLeave(e) {
        this.isHover = false
        // console.log('222222222222222222222')
        // this.$refs.more.$el.style.cssText = 'width: 230px;height: 51px;color: #FFFFFF;';
      },
    },
  }
</script>

<style scoped>

  .left {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -47%);
    padding-left: 7.71vw;
  }

  .logo {
    width: 90px;
    height: 90px;
  }

  .title {
    width: 260px;
    font-size: 60px;
    font-family: SourceHanSerifCN-Heavy, SourceHanSerifCN;
    font-weight: 800;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    left: 50%;
    margin-left: -130px;
    top: 0;
    z-index: 10;
  }

  .title-line-box {
    width: 245px;
    position: absolute;
    bottom: 0px;
    left: 0;
  }

  .titleLine {
    width: 100%;
    height: 26px;
    background: #FFCCC0;
  }

  .titleLine-animation {
    width: 100%;
    height: 26px;
    background: #FFFFFF;
    position: absolute;
    top: 0;
    left: 0;
  }

  .content {
    max-width: 500px;
    min-width: 240px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 30px;
    margin-top: 60px;
  }

  .btn-more {
    width: 230px;
    height: 51px;
    color: #FFFFFF;
    /*overflow: hidden;*/
  }

  .btn-more-box {
    width: 230px;
    height: 51px;
    margin-top: 60px;
    border: 1px solid #000000;
    color: #000000;
    position: relative;
  }

  .btn-more-text {
    width: 230px;
    height: 51px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 200;
    font-size: 16px;
    font-weight: 600;
  }


  .code-box {
    width: 230px;
    margin-top: 20px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
  }

  .code-content {
    width: 120px;
    height: 168px;
    background: url("../../../assets/images/bg_code.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    /*border: 2px solid rgba(0, 0, 0, 0.04);*/
  }


  .btn-more:after {
  }

  .btn-more-hover {
    width: 230px;
    background: #000000;
    border: 1px solid #000000;
    -webkit-animation: fadeIn 0.3s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: fadeIn 0.3s linear 1;
    animation-fill-mode: forwards;
  }

  .titleLine-animation-index {
    -webkit-animation: spin 0.8s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: spin 0.8s linear 1;
    animation-fill-mode: forwards;
    /*background: #ff0000;*/
  }

  /*定义动画*/
  @-webkit-keyframes spin { /*兼容性写法。spin是关键帧的动画名称*/
    from { /*动画起始状态*/
      -webkit-transform: translateX(0px);
    }
    to { /*动画结束状态*/
      -webkit-transform: translateX(245px);
    }
  }

  @keyframes spin {
    from {
      transform: translateX(0px);
    }
    to {
      transform: translateX(245px);
    }
  }

  @-webkit-keyframes fadeIn { /*兼容性写法。spin是关键帧的动画名称*/
    from {
      width: 0px;
      /*transform: translateX(0px);*/
      background: #FFFFFF;
    }
    to {
      width: 100%;
      /*transform: translateX(240px);*/
      background: #000000;
    }
  }

  @keyframes fadeIn {
    from {
      width: 0px;
      /*transform: translateX(0px);*/
      background: #FFFFFF;
      border: 1px solid #000000;
    }
    to {
      width: 100%;
      /*transform: translateX(240px);*/
      background: #000000;
      border: 1px solid #000000;
    }
  }


  @media screen and (max-width: 1300px) {


    .content {
      max-width: 350px;
      min-width: 240px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      line-height: 30px;
      margin-top: 60px;
    }
  }


  /**********************************  移动端********************************************/

  .content-m {
    width: 6.54rem;
    font-size: 0.26rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 0.44rem;
  }

  .title-m {
    width: 100%;
    font-size: 0.4rem;
    font-family: SourceHanSerifCN-Heavy, SourceHanSerifCN;
    font-weight: bolder;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    text-align: center;
    left: 0;
    top: 0;
    z-index: 10;
  }

  .title-line-box-m {
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0;
  }

  .titleLine-m {
    width: 100%;
    height: 0.16rem;
    background: #FFCCC0;
  }

  .titleLine-animation-m {
    width: 100%;
    height: 0.16rem;
    background: #f0f2f5;
    position: absolute;
    top: 0;
    left: 0;
  }

  .titleLine-animation-index-m {
    -webkit-animation: spinm 0.8s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: spinm 0.8s linear 1;
    animation-fill-mode: forwards;
    /*background: #ff0000;*/
  }


  .btn-more-box-m {
    width: 2.02rem;
    height: 0.64rem;
    border-radius: 4px;
    border: 1px solid #000000;
    margin-top: 0.48rem;
    font-size: 0.24rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    cursor: pointer;
    z-index: 500;
  }

  .btn-more-text {
    width: 230px;
    height: 51px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 200;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
  }

  .home-item {
    width: 5.34rem;
    height: 2.92rem;
    background: #ffffff;
  }

  .cover-m {
    width: 1.92rem;
    height: 1.92rem;
    margin-left: 0.2rem;
    margin-top: 0.2rem;
  }

  .time-box-m {
    width: 68.56%;
    height: 2.32rem;
    background: #ffffff;
    position: relative;
    margin-left: 0.2rem;
  }


  .time-title-m {
    font-size: 0.32rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 0.32rem;
    line-height: 0.32rem;
  }

  .time-subtitle-m {
    font-size: 0.24rem;
    font-family: DIN-Light, DIN;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.25);
    margin-top: 0.1rem;
  }

  .time-content-m {
    width: 90%;
    font-size: 0.22rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 0.28rem;
    margin-top: 0.15rem;
    text-align: justify;
  }


  .floating-img-m {
    width: 0.44rem;
    height: 0.44rem;
    position: absolute;
    right: 33px;
    top: -20px;
    z-index: 100;
  }

  .wxapp-img-m {
    height: 70%;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    bottom: -2rem;
  }

  /*定义动画*/
  @-webkit-keyframes spinm { /*兼容性写法。spin是关键帧的动画名称*/
    from { /*动画起始状态*/
      -webkit-transform: translateX(0%);
    }
    to { /*动画结束状态*/
      -webkit-transform: translateX(100%);
    }
  }

  @keyframes spinm {
    from {
      -webkit-transform: translateX(0%);
    }
    to {
      -webkit-transform: translateX(100%);
    }
  }


  .fontE4 {
    display: -webkit-box;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
  }


  /*  *************************************************************************************/


</style>



// WEBPACK FOOTER //
// src/page/home/components/HomeFourth.vue